"use client"

import { SimpleGrid, Box, SkeletonCircle, SkeletonText } from '@chakra-ui/react'

function FirmCardSkeleton () {
  return (
    <Box w='100%' p={6} boxShadow='md' bg='white' justify='center' align='center'>
      <SkeletonCircle size='24' mb={4} />
      <SkeletonText skeletonHeight={2} />
    </Box>
  )
}

export default function SkeletonGroup() {
  return (
    <SimpleGrid mt={24} columns={[1, 2, 3]} spacing={10}>
      <FirmCardSkeleton />
      <FirmCardSkeleton />
      <FirmCardSkeleton />
      <FirmCardSkeleton />
      <FirmCardSkeleton />
      <FirmCardSkeleton />
    </SimpleGrid>
  )
};